/* -------------------------------------
* Utility Functions
*
* util.getCookie();
* util.setCookie();
* util.checkCookie();
* util.getQueryParam();
* ------------------------------------- */

// Useful Global $Vars
import {CountUp} from "countup.js";

var $document = jQuery(document),
    $body = jQuery('body'),
    $window = jQuery(window);

var util = {

    // Gets a cookie and returns the cookies value, if no cookie exists it returns blank "".
    getCookie: function (c_name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(c_name + '=');
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                var c_end = document.cookie.indexOf(';', c_start);
                if (c_end == -1) {
                    c_end = document.cookie.length;
                }
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return '';
    },

    // Sets a cookie with your given ("cookie name", "cookie value", "good for x days").
    setCookie: function (c_name, value, expiredays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + expiredays);
        document.cookie = c_name + '=' + escape(value) + ((expiredays == null) ? '' : '; expires=' + exdate.toUTCString()) + '; path=/';
    },

    // Checks to see if a cookie exists, then returns boolean (true/false).
    checkCookie: function (c_name) {
        c_name = util.getCookie(c_name);
        return ((c_name != null && c_name != '') ? true : false);
    },

    // Gets a query string parameter value by name.
    // Defaults to location.href but can accept any URL to parse.
    getQueryParam: function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    destyleMarketoForm: function (mktoForm, moreStyles) {

        var formEl = mktoForm.getFormElem()[0],
            arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

        // remove element styles from <form> and children
        var styledEls = arrayFrom(formEl.querySelectorAll('[style]')).concat(formEl);
        styledEls.forEach(function (el) {
            el.removeAttribute('style');
        });

        // disable remote stylesheets and local <style>s
        var styleSheets = arrayFrom(document.styleSheets);
        styleSheets.forEach(function (ss) {
            if ([mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 || formEl.contains(ss.ownerNode)) {
                ss.disabled = true;
            }
        });

        if (!moreStyles) {
            formEl.setAttribute('data-styles-ready', 'true');
        }

    }

};

function getPrefersReducedMotion() {
    const QUERY = '(prefers-reduced-motion: no-preference)';
    const mediaQueryList = window.matchMedia(QUERY);
    const prefersReducedMotion = !mediaQueryList.matches;

    return prefersReducedMotion;
}

// TODO: setup setting change stop animations
// const QUERY = '(prefers-reduced-motion: no-preference)';
// const mediaQueryList = window.matchMedia(QUERY);
// const listener = (event) => {
//     const getPrefersReducedMotion = getPrefersReducedMotion();
//     // kill animations
// };
// mediaQueryList.addListener(listener);
// Later:
// mediaQueryList.removeListener(listener);

window.addEventListener('DOMContentLoaded', function () {
    // Adjust initial-scale for various pixel ratios
    // try {
    //     document.querySelector("meta[name=viewport]").setAttribute('content', 'width=device-width, height=device-height, shrink-to-fit=no, initial-scale='+(1/window.devicePixelRatio)+'');
    // } catch (e) {
    //     //
    // }

    // ACKNOWLEDGEMENT
    console.log('%c Website powered by WebMechanix - https://www.webmechanix.com/', 'color: #2A8DC1');
});

window.addEventListener('load', function () {

    // SETUP OBSERVER FOR STAT COUNTERS
    let observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let entryVal = entry.target.innerHTML.match(/\d/g).join('');
                    let options = {
                        // startVal: entry.dataset.start,
                        duration: entry.target.dataset.duration,
                        prefix: entry.target.dataset.prefix,
                        suffix: entry.target.dataset.suffix,
                    };
                    let counter = new CountUp(entry.target, entryVal, options);
                    if (!counter.error) {
                        counter.start()
                    } else {
                        console.error(counter.error);
                    }
                    observer.unobserve(entry.target);
                }

            });
        },
        {rootMargin: '0px 0px -0px 0px'}
    );

    document.querySelectorAll('.stat-counter').forEach(stat => {
        observer.observe(stat)
    });


    // SETUP OBSERVER FOR TIMELINE
    var timelineTimeout;
    let observerTimeline = new IntersectionObserver(
        (entries, observerTimeline) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // clearTimeout(timelineTimeout);
                    // disableScroll();
                    // timelineTimeout = setTimeout(enableScroll,2000);
                    entry.target.click();
                    // observerTimeline.unobserve(entry.target);
                }
            });
        },
        {
            root: null,
            rootMargin: "-50% 0px -50% 0px"
        }
    );


    if($(window).scrollTop() === 0 && window.outerWidth >= 768) {
        document.querySelectorAll('.block--timeline .nav-item > a[data-toggle="tab"]').forEach(item => {
            observerTimeline.observe(item)
        });
    }
})


jQuery(document).ready(function ($) {
    // Focus on search form when shown from collapse
    $('#search-form').on('shown.bs.collapse', function () {
        $(this).find('input[name="s"]').focus();
    })

    // Nav swap on scroll
    jQuery(window).on('scroll', _.throttle(checkNav, 100)); // lodash throttle function
    jQuery(window).on('resize', _.throttle(checkNav, 100)); // lodash throttle function
    checkNav();

    function checkNav() {
        var scroll = $(window).scrollTop();
        var header = $('#header');
        // var utilityNav = $('#utility-nav');
        if (scroll > 10 && !header.hasClass('header--alt')) {
            header.addClass('header--alt')

            setTimeout(function(){
                subNavPosition();
            }, 500);

            // utilityNav.collapse('hide');
        } else if (scroll <= 10 && header.hasClass('header--alt')) {
            header.removeClass('header--alt')
            // utilityNav.collapse('show');
        }
    }

    // CREATE PAGE SUBMENU
    function subNavPosition() {
        var $subheader = $('.subheader-menu');
        // console.log($('#header').innerHeight())
        $subheader.css('top', $('#header').innerHeight());
    }

    function subheaderMenuPosition() {
        var $subheader = $('.subheader-menu');
        if (!$subheader.hasClass('d-none')) {
            $subheader.css('top', $('#header').innerHeight()).addClass('d-none d-md-block');
        }
    }

    var $subheader = $('.subheader-menu');
    var $subheaderLinks = $('.subheader-menu-link');

    if ($subheaderLinks.length > 0) {
        var $nav = $subheader.find('nav');
        // console.log($nav);

        $subheaderLinks.each(function () {
            $nav.append($(this));
            $(this).removeClass('d-none');
        })

        setTimeout(function(){
            subNavPosition();
        }, 500);

        $('body').scrollspy({target: '#subheader-menu-nav', offset: 300})
        // $('[data-spy="scroll"]').each(function () {
        //     var $spy = $(this).scrollspy('refresh')
        // })

        subheaderMenuPosition();
    } else {
        $subheader.addClass('d-none');
    }


    // HUBSPOT FORM READY LISTENER
    window.addEventListener('message', event => {
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
            // IF FIELD EXISTS POPULATE WITH URL
            try {
                var inputUtmUrl = document.querySelector('[name="utm_page_url"]');
                inputUtmUrl.value = window.location;
            } catch (e) {
                //
            }


            // FORM LABEL ANIMATION
            if (!getPrefersReducedMotion()) {
                $('.hs-form label').addClass('animate-label').each(function(){
                    if ($(this).val() == "") {
                        $(this).addClass("animate-label--focus");
                    }
                });
                $('.hs-input').focus(function () {
                    var $this = $(this);
                    $("label[for='" + $this.attr('id') + "']").addClass("animate-label--focus");
                });
                $('.hs-input').blur(function () {
                    var $this = $(this);
                    if ($this.val() == "") {
                        $("label[for='" + $this.attr('id') + "']").removeClass("animate-label--focus");
                    }
                });
            }

            // INPUT TYPE SUBMIT BUTTON STYLING
            $('.actions > input.hs-button').each(function () {
                $(this).wrap('<span class="btn btn-outline-primary"></span>');
                $(this).focus(function () {
                    $(this).parent().addClass('hs-button--focus');
                });
                $(this).blur(function () {
                    $(this).parent().removeClass('hs-button--focus');
                });
            })
        }
    });

    // video slider modal trigger modal with keyboard ENTER
    $('.slide--wrapper').keypress(function (e) {
        if (e.which === 13) { // enter key
            $($(this).data('target')).modal();
        }
    })
});



// SETUP TO SCROLL JACK
// // left: 37, up: 38, right: 39, down: 40,
// // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
// var keys = {37: 1, 38: 1, 39: 1, 40: 1};
//
// function preventDefault(e) {
//     e.preventDefault();
// }
//
// function preventDefaultForScrollKeys(e) {
//     if (keys[e.keyCode]) {
//         preventDefault(e);
//         return false;
//     }
// }
//
// // modern Chrome requires { passive: false } when adding event
// var supportsPassive = false;
// try {
//     window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
//         get: function () { supportsPassive = true; }
//     }));
// } catch(e) {}
//
// var wheelOpt = supportsPassive ? { passive: false } : false;
// var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
//
// // call this to Disable
// function disableScroll() {
//     window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
//     window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
//     window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
//     window.addEventListener('keydown', preventDefaultForScrollKeys, false);
// }
//
// // call this to Enable
// function enableScroll() {
//     window.removeEventListener('DOMMouseScroll', preventDefault, false);
//     window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
//     window.removeEventListener('touchmove', preventDefault, wheelOpt);
//     window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
// }
